module.exports = __webpack_public_path__ + "assets/videos/SpokePromo-e791411f4dab519586d9c1600385b20e.webm";